import { useCommandStore } from '@/stores/useCommandStore'
import { useCallback, useEffect } from 'react'

export function useKeyboardShortcuts() {
  const toggleCommand = useCommandStore((s) => s.toggle)

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    const cmdOrCtrl = e.metaKey || e.ctrlKey

    if (cmdOrCtrl && e.key.toLowerCase() === 'k') {
      e.preventDefault()
      toggleCommand()
      return
    }
  }, [toggleCommand])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])
}
